import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { mergeCells, COLUMNS, DATA_AUTHORITY_TYPE, AUTHORITY_TAGTYPE, deWidthFn } from './utils';
import { roleMyConfig, roleConfigDataStore } from './request';
import { customerDetail } from '../../system/customerManage/request';
import dataAuthorityDepartment from './dataAuthorityDepartmentModal.vue';
export default {
  name: 'data-authority',
  components: {
    dataAuthorityDepartment
  },
  data() {
    const h = this.$createElement;
    return {
      currentColumns: [],
      DATA_AUTHORITY_TYPE,
      tableData: [],
      a: '123',
      columns: [{
        slots: {
          title: '菜单'
        },
        dataIndex: 'menuName',
        align: 'center',
        width: 180,
        key: 'menuName',
        customRender: (text, row, index) => {
          const obj = {
            children: this.$t(text),
            attrs: {
              rowSpan: row.menuNameRowSpan
            }
          };
          return obj;
        }
      }, {
        slots: {
          title: '数据权限'
        },
        dataIndex: 'dataAuthority',
        key: 'dataAuthority',
        align: 'center',
        width: 350,
        // scopedSlots: {customRender: 'dataAuthority'},
        customRender: (text, row, index) => {
          const person = value => {
            // debugger;
            if (value === 1) {
              return h("span", {
                "style": "color:#aaaaaa;"
              }, [" (", this.$t('包含下级关联数据'), ")"]);
            } else if ((value === 3 || value === 4) && row.authorityTypeValue === value) {
              return h("span", {
                "class": "data-scope",
                "on": {
                  "click": () => this.onChangeAuthorityRadio(row, 'add')
                }
              }, ["+ ", this.$t('数据范围')]);
            }
          };
          const a = h("a-radio-group", {
            "attrs": {
              "value": row.authorityTypeValue
            },
            "on": {
              "change": e => this.authorityTypeChange(e, row)
            }
          }, [DATA_AUTHORITY_TYPE.map(item => h("a-radio", {
            "style": "display:block;width:100%;height: 30px;line-height: 30px;text-align:left",
            "attrs": {
              "value": item.value
            }
          }, [this.$t(item.name), person(item.value)]))]);
          return {
            children: a,
            attrs: {
              rowSpan: row.menuNameRowSpan
            }
          };
        }
      }],
      authorityType: null,
      isSubmitState: false
    };
  },
  async created() {
    await this.getauthorityType();
    await this.initListData();
  },
  methods: {
    isOperate(record) {
      if (record.agencyId || record.applicationId || record.customerId || record.structureId) {
        return false;
      }
      return true;
    },
    // 获取权限加载类型
    async getauthorityType() {
      const res = await customerDetail({
        customerId: Number(this.$route.params.id.split(',')[1])
      });
      this.authorityType = res.tag;
    },
    // 切换数据权限radioStyle
    authorityTypeChange(e, row) {
      row.authorityTypeValue = e.target.value;
      this.tableData = deWidthFn(this.tableData, 'permissionsId', row.permissionsId).map(item => {
        if (item.permissionsId === row.permissionsId) {
          item.agencyId = '';
          item.agencyName = '';
          item.appName = '';
          item.applicationId = '';
          item.customerId = '';
          item.customerName = '';
          item.structureId = '';
          item.structureName = '';
        }
        return item;
      }).sort((a, b) => a.permissionsId - b.permissionsId);
      this.tableData = mergeCells(this.tableData, 'menuName', e.target.value, row.permissionsId);
    },
    // 更新临时列表数据（增改删）
    updateTemporaryTableData({
      data,
      authorityType
    }) {
      this.tableData = mergeCells(data, 'menuName').map(item => {
        if (!item.authorityTypeValue) {
          item.authorityTypeValue = authorityType;
        }
        return item;
      });
    },
    // 获取表格列表数据
    async initListData() {
      this.currentColumns = [];
      let data = {
        roleId: Number(this.$route.params.id.split(',')[0]),
        customerId: Number(this.$route.params.id.split(',')[1])
      };
      const res = await roleMyConfig(data);
      if (this.authorityType !== 1) {
        AUTHORITY_TAGTYPE[this.authorityType].map(i => {
          COLUMNS.map(item => {
            if (item.dataIndex == i) {
              item.slots = {
                title: item.title
              };
              delete item.title;
              this.currentColumns.push(item);
            }
          });
        });
        this.columns = this.columns.concat(this.currentColumns);
      } else {
        this.columns = this.columns.concat(COLUMNS);
      }
      this.tableData = mergeCells(res, 'menuName').map(item => {
        item.authorityTypeValue = item.rolePermissionsType ? item.rolePermissionsType : 1;
        return item;
      }).sort((a, b) => a.permissionsId - b.permissionsId);
    },
    // 删除权限数据
    onDelete(record, index) {
      let arr = this.tableData.filter(item => item.permissionsId === record.permissionsId);
      if (arr.length > 1) {
        this.tableData.splice(index, 1);
      } else {
        this.tableData.map(item => {
          if (item.permissionsId === record.permissionsId) {
            item.agencyId = '';
            item.agencyName = '';
            item.appName = '';
            item.applicationId = '';
            item.customerId = '';
            item.customerName = '';
            item.structureId = '';
            item.structureName = '';
            return item;
          }
        });
      }
      this.tableData = mergeCells(this.tableData, 'menuName');
    },
    // 确认数据权限
    async onConfirmAuthority() {
      let obj = {
        roleId: Number(this.$route.params.id.split(',')[0]),
        customerId: Number(this.$route.params.id.split(',')[1]),
        config: []
      };
      deWidthFn(this.tableData, 'permissionsId').map(item => {
        obj.config.push({
          menuId: item.permissionsId,
          type: item.authorityTypeValue,
          config: []
        });
      });
      obj.config.map(item => {
        this.tableData.map(currentItem => {
          let currentMenuInfo = {};
          if (currentItem.permissionsId === item.menuId && item.type !== 1 && item.type !== 2) {
            if (item.type === 3 && currentItem.applicationId && currentItem.structureId || item.type === 4 && currentItem.applicationId) {
              this.isSubmitState = true;
            } else {
              // debugger;
              // 理赔审核V2查看应用非必填  id:325
              if (currentItem.permissionsId === 325 && (item.type === 3 && currentItem.structureId || item.type === 4)) {
                this.isSubmitState = true;
              } else {
                this.isSubmitState = false;
              }
            }
            currentMenuInfo.structure = currentItem.structureId;
            currentMenuInfo.application = currentItem.applicationId;
            currentMenuInfo.agency = currentItem.agencyId;
            currentMenuInfo.customer = currentItem.customerId;
            item.config.push(currentMenuInfo);
          }
        });
      });
      let allRes = this.tableData.find(i => i.authorityTypeValue == 3 || i.authorityTypeValue == 4);
      if (this.isSubmitState || !allRes) {
        const res = await roleConfigDataStore(obj);
        if (res) {
          this.$router.push('/customer/roleManage');
        }
        this.isSubmitState = false;
      } else {
        this.$message.error(this.$t('请选择') + this.$t('数据'));
      }
    },
    //   数据权限状态改变
    onChangeAuthorityRadio(row, type) {
      if (row.authorityTypeValue === 3 || row.authorityTypeValue === 4) {
        this.$refs.authorityDepartmentRef.openModal(row, type, this.tableData);
      }
    }
  }
};